import React from "react";

function MagnifierIcon({css}) {
  return (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className={`header-transition ${css}`} xmlns="http://www.w3.org/2000/svg">
    <path className="stroke-current" d="M27 26.9993L21.0187 21.0074L27 26.9993ZM24.3333 12.9993C24.3333 16.0051 23.1393 18.8878 21.0139 21.0132C18.8885 23.1386 16.0058 24.3327 13 24.3327C9.9942 24.3327 7.11153 23.1386 4.98611 21.0132C2.8607 18.8878 1.66666 16.0051 1.66666 12.9993C1.66666 9.99356 2.8607 7.11088 4.98611 4.98547C7.11153 2.86006 9.9942 1.66602 13 1.66602C16.0058 1.66602 18.8885 2.86006 21.0139 4.98547C23.1393 7.11088 24.3333 9.99356 24.3333 12.9993V12.9993Z" strokeWidth="2" strokeLinecap="round"/>
  </svg>  
  );
}

export default MagnifierIcon;
